// Mirror of EuropassPdfIntroductionSection.jsx: bullet title + justified intro.

import { AlignmentType } from "docx";
import { bulletSectionTitle, run } from "../../shared/wordHelpers";
import { FONT_VERDANA } from "../../shared/wordTheme";
import { EU_INDENT, euPara } from "../euLayout";

export function buildEuropassIntroduction( { data, translations } ) {
    const { introduction } = data;
    const hasIntroduction = typeof introduction === "string"
        ? introduction.trim() !== ""
        : Boolean( introduction );
    if ( !hasIntroduction ) {
        return [];
    }

    return [
        ...bulletSectionTitle( translations?.pdf?.introductionLabel, { font: FONT_VERDANA, indent: EU_INDENT } ),
        euPara( run( introduction, { pt: 10, font: FONT_VERDANA } ), { alignment: AlignmentType.JUSTIFIED } ),
    ];
}
